module.exports = __webpack_public_path__ + "static/media/waybill-inventory.2eb61462.svg";